import _ from "lodash";
import { call, put } from "redux-saga/effects";
import { isEqual, find, remove, findIndex } from "lodash";
import endpoint from "./config/Axios";
import Logo from "./assets/images/logo-1.png";
import DashboardRight from "./assets/images/dashboardRight.svg";
import RoleIcon from "./assets/icons/business.svg";
import LoaderIcon from "./assets/images/dots_loading_2.gif";
import UserDashMobile from "./assets/images/user_dash_mob.png";

export const RouteConstants = {
  ROOT: "/",
  DASHBOARD: "/dashboard/",
  REPORTS: "/reports/",
  EXPENSES: "/expenses/",
  TRIPS: "/trips/",
  ADVANCES: "/advances/",
  CARDS: "/cards/",
  CARD_DETAILS: "/card-details/",
  CARD_TRANSACTIONS: "/card-transactions/",
  CARD_INVENTORY: "/card-inventory/",
  TRANSFERS: "/transfers/",
  QUICK_TRANSFERS: "/transfers/quick-transfers/",
  BULK_TRANSFERS: "/transfers/bulk-transfers/",
  TRANSFERS_LOG: "/transfers/transfers-log/",
  USER_LOGS: "/checker/user-logs",
  CHECKER_TRANSFERS: "/transfers",
  TRANSFERS_REPORTS: "/transfers/transfers-reports/",
  ACCOUNT: "/account/",
  ACCOUNT_TRANSACTIONS: "/account-transaction/",
  ANALYTICS: "/analytics",
  SETTINGS: "/setting/",
  POLICIES: "/policies/",
  RESETPASSWORD: "/reset-password",
  FORGOTPASSWORD: "/forgot-password/",
  SETTING_ORGANISATION: "/setting/organisation/",
  SETTING_ORGANISATION_MANAGE: "/setting/organisation/manage",
  SETTING_USERS: "/setting/users/",
  SETTING_CHECKERS: "/setting/checkers/",
  SETTING_USERS_ADD_USER: "/setting/users/add_user/",
  SETTING_ROLES: "/setting/roles/",
  SETTING_GRADES: "/setting/grades/",
  SETTING_CUSTOM_FIELD: "/setting/custom_field/",
  SETTING_CATEGORIES: "/setting/categories/",
  SETTING_POLICIES: "/setting/policies/",
  SETTING_POLICIES_EXPENSE: "/setting/policies/expense/",
  SETTING_POLICIES_CARDS: "/setting/policies/cards/",
  SETTING_APPROVALS: "/setting/approvals/",
  SETTING_APPROVALS_ADVANCE: "/setting/approvals_advance/",
  SETTING_APPROVALS_TRIP: "/setting/approvals_trip/",
  SETTING_CUSTOMISATION: "/setting/customisation/",
  SETTING_CUSTOMISATION_EXPENSES: "/setting/customisation/expenses/",
  SETTING_CUSTOMISATION_REPORTS: "/setting/customisation/reports/",
  SETTING_CUSTOMISATION_ADVANCES: "/setting/customisation/advances/",
  SETTING_CUSTOMISATION_TRIPS: "/setting/customisation/trips/",
  SETTING_CUSTOMISATION_COSTCENTER: "/setting/customisation/cost_center/",
  SETTING_CUSTOMISATION_MERCHANT: "/setting/customisation/merchant/",
  SETTING_CUSTOMISATION_PROJECTS: "/setting/customisation/projects/",
  SETTING_CUSTOMISATION_REIMBURSEMENTS:
    "/setting/customisation/reimbursements/",
};

export const roleCCMapping = {
  cc_user_approvals: "/checker/users",
  cc_transfer_approvals: "/checker/transfers",
  c_user_logs: "/checker/user-logs",
  cc_transfer_logs: "/transfers/transfers-log/",
};

export const roleRouteMapping = {
  company: "",
  dashboard: "/dashboard",
  expense_reports: "/reports",
  expenses: "/expenses",
  trips: "/trips",
  advances: "/advances",
  cards: "/cards",
  transfers: "/transfers/quick-transfers/",
  account: "/account",
  analytics: "/analytics",
  employees: "",
  transactions: "",
  organisation_settings: "/setting/organisation",
  users_and_controls: "/setting/users",
  categories: "/setting/categories",
  policies_and_limits: "/setting/policies/expense",
  approvals: "/setting/approvals/",
  expense_settings: "/setting/customisation/expenses/",
  reports_settings: "/setting/customisation/reports/",
  advances_settings: "/setting/customisation/advances/",
  trips_settings: "/setting/customisation/trips/",
  projects: "/setting/customisation/projects/",
  reimbursements: "",
  cost_center: "/setting/customisation/cost_center/",
  merchants: "/setting/customisation/merchant/",
  company_base_currencies: "",
};

export const GLOBAL_STATIC_FILES = {
  COMPANY_LOGO: Logo,
  DASHBOARD_RIGHT: DashboardRight,
  ROLE_ICON: RoleIcon,
  LOADER: LoaderIcon,
  USER_DASH_MOBILE: UserDashMobile,
};

export const ActionTypesFactory = (prefix, type) => {
  let p = _.upperCase(prefix) + "/" + _.upperCase(type);
  return {
    REQUEST: p + "_REQUEST",
    INPROGRESS: p + "_INPROGRESS",
    SUCCESS: p + "_SUCCESS",
    FAILED: p + "_FAILED",
    CHANGED: p + "_CHANGED",
    RESET: p + "_RESET",
    custom: (name) => {
      return `${p}_${name}`;
    },
  };
};

export const isSettings = () => {
  return (
    hasAccess("organisation_settings", "read") ||
    hasAccess("users_and_controls", "read") ||
    hasAccess("categories", "read") ||
    hasAccess("policies_and_limits", "read") ||
    hasAccess("advances_settings", "read") ||
    hasAccess("expense_settings", "read") ||
    hasAccess("trip_settings", "read") ||
    hasAccess("reports_settings", "read") ||
    hasAccess("approvals", "read") ||
    hasCustomize()
  );
};

export const hasCustomize = () => {
  return (
    hasAccess("expense_settings", "read") ||
    hasAccess("reports_settings", "read") ||
    hasAccess("advances_settings", "read") ||
    hasAccess("trips_settings", "read") ||
    hasAccess("projects", "read") ||
    hasAccess("cost_center", "read") ||
    hasAccess("merchants", "read")
  );
};

export const sagaFunctions = (action_type, method, api, data, config = {}) => {
  return function* () {
    let res = null;
    console.log(data, "data in saga");
    const params = data?.params;
    delete data?.params;
    try {
      if (method === "post" || method === "put") {
        res = yield call(endpoint[method], api, data, {
          params,
          ...config,
        });
      } else {
        res = yield call(endpoint[method], api, {
          params: data,
          ...config,
        });
      }
      if (res.status < 400) {
        yield put({
          type: action_type.SUCCESS,
          payload: res.data,
        });
      } else {
        yield put({
          type: action_type.FAILED,
          payload: res.data,
        });
      }
    } catch (err) {
      yield put({
        type: action_type.FAILED,
        payload: err?.response?.data,
      });
    }
  };
};

export const ReducerFunctions = (ActionType, initialState) => {
  return function (state = initialState, action) {
    let data = Array.isArray(action?.payload)
      ? [...action?.payload]
      : { ...action?.payload };
    switch (action?.type) {
      case ActionType.REQUEST:
        return {
          ...state,
          loading: true,
          success: null,
        };
      case ActionType.SUCCESS: {
        return {
          ...state,
          data,
          loading: false,
          success: true,
        };
      }
      case ActionType.FAILED:
        return {
          ...state,
          data,
          loading: false,
          success: false,
        };
      case ActionType.RESET:
        return {
          loading: false,
        };

      default:
        return state;
    }
  };
};

export const objectToFormData = (obj, form, namespace) => {
  const fd = form || new FormData();

  if (obj === null || obj === undefined) {
    return fd;
  }

  if (Array.isArray(obj)) {
    obj.forEach((value, index) => {
      const key = namespace ? `${namespace}[${index}]` : index;
      if (
        typeof value === "object" &&
        !(value instanceof File) &&
        value !== null
      ) {
        objectToFormData(value, fd, key);
      } else {
        fd.append(key, value);
      }
    });
  } else if (typeof obj === "object" && !(obj instanceof File)) {
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        const key = namespace ? `${namespace}.${property}` : property;
        if (
          typeof obj[property] === "object" &&
          obj[property] !== null &&
          !(obj[property] instanceof File)
        ) {
          objectToFormData(obj[property], fd, key);
        } else {
          fd.append(key, obj[property]);
        }
      }
    }
  } else {
    fd.append(namespace, obj);
  }

  console.log("🚀 ~ objectToFormData ~ fd:", fd);
  return fd;
};

export const capitalize = ([first, ...rest], lowerRest = false) =>
  first.toUpperCase() + rest.join("").toLowerCase();

export const getBoolVal = (val) => {
  if (val === true || val === "true") {
    return true;
  }
  if (val === false || val === "false") {
    return false;
  }
  return val;
};

export const getKycStatus = (type) => {
  switch (type) {
    case "GNI":
      return;
    case "INA":
      return;
    case "A":
      return;
    case "Y":
      return;
    case "THL":
      return;
    case "PHL":
      return;
    default:
      return "";
  }
};

export const isEqualLodash = (value, other) => isEqual(value, other);
export const findLodash = (array, object) => find(array, object);
export const removeLodash = (array, object) => remove(array, object);
export const findIndexLodash = (array, object) => findIndex(array, object);

export const hasAccess = (module, key) => {
  let menuAccess = sessionStorage.getItem("menu")
    ? JSON.parse(sessionStorage.getItem("menu"))
    : {};

  if (
    (menuAccess && menuAccess?.[module]?.includes(key)) ||
    // eslint-disable-next-line
    sessionStorage.getItem("is_admin") == "false"
  ) {
    return true;
  }

  return false;
};

export const isEqualObject = (fromPayload, toPayload) =>
  JSON.stringify(fromPayload) === JSON.stringify(toPayload);

const currencyFormat = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

export const amountFormat = (amount) => {
  return Number.isNaN(Number(amount))
    ? "-"
    : currencyFormat.format(parseFloat(amount));
};

export const getWidth = (arr, val) => {
  return (val / Math.max(...arr)) * 100;
};

export const isSuperAdmin = () => {
  let bool = sessionStorage.getItem("is_super_admin");
  // eslint-disable-next-line
  return bool == "true" ? true : false;
};
